// src/TermsOfUse.js
import './asset/App.css';
import Header from './component/Header';
import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

function TermsOfUse() {

    return (
      <div className="App">
        <Header />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '95%', margin: 'auto' }}>
            <Typography variant="h4" sx={{ textAlign: 'left', mt: 3, mb: 3 }}>
            線上填寫勞務報酬單系統服務使用條款
            </Typography>
        </div>
        <Box>
            <Container maxWidth="md" sx={{ mt: 3 }}>  
                <div style={{ textAlign: 'left' }}>
                <p>一、認知與接受條款</p>
                <p>(一) 「線上填寫勞務報酬單系統（以下簡稱本系統）」係由「內容電力有限公司（以下簡稱本公司）」所開發及經營，並依「線上填寫勞務報酬單系統服務使用條款（以下簡稱本服務使用條款）提供使用者」線上填寫勞務單服務 (以下簡稱「本服務」)。當您使用本服務時，即表示您已閱讀、瞭解並同意接受本服務使用條款之所有內容。此外，當您使用本系統的特定服務時，可能會依據該特定服務之性質，而須遵守本系統所另行公告之服務使用條款或相關規定。此另行公告之服務使用條款或相關規定亦均併入屬於本服務使用條款之一部分。本系統有權於任何時間修改或變更本服務使用條款之內容，建議您隨時注意該等修改或變更。您於任何修改或變更後繼續使用本服務，視為您已閱讀、瞭解並同意接受該等修改或變更。如果您不同意本服務使用條款的內容，或者您所屬的國家或地域排除本服務使用條款內容之全部或一部時，您應立即停止使用本服務。</p>
                <p>(二) 使用者同意使用本服務之意思表示等，皆以電子文件為表示方式。</p>
                <p>(三) 如未滿十八歲之未成年人使用本系統提供之服務時，應得法定代理人同意，並遵守本系統及相關法律規定。若該未成年使用者與交易相對人或其他第三人，因使用本系統服務所發生之糾紛，本系統概不負責。當未滿十八歲的您使用或繼續使用本系統時，即表示您的法定代理人(或監護人) 已閱讀、瞭解並同意接受本服務使用條款之所有內容及其後續之修改或變更。」。</p>
                <p>二、註冊義務</p>
                <p>為了能使用本系統之服務，您同意以下事項：</p>
                <p>(一) 請依註冊申請程序所提示之項目，登錄您本人正確、真實及完整之個人資料。當您的個人資料有異動時，請立即更新，以維持您個人資料之正確、真實及完整。如因您登錄不實資料或冒用他人名義以致於侵害他人之權利或違法時，應自負法律責任。</p>
                <p>(二) 維持並更新您個人資料，確保其為正確、最新及完整。若您提供任何錯誤、不實或不完整的資料，本系統有權暫停或終止您的帳號，並拒絕您使用本系統之全部或一部。若因使用者資料不實，使本網站或第三者所受到的損失，由涉此事件的使用者來承擔負責。</p>
                <p>(三) 當您成為本服務之使用者後而得使用之本系統各項服務，其所有權仍屬「本服務」及其所約定之人所有，使用者僅得依「本服務使用條款」之約定使用，不得出租、出借、移轉或讓與給其他第三人使用。</p>
                <p>三、個人資料之保護與隱私權保護</p>
                <p>(一) 當使用者使用本系統時，您於註冊資料中之個人資料或其他資料，本公司將依個人資料保護法及相關法令之規定，只就其特定目的，為承辦所提供服務之用，不會任意對其他第三者揭露。本公司不會將其做為超出蒐集之特定目的以外的用途，亦不會任意對其他第三者揭露。關於更詳盡的說明請參閱「使用者隱私權政策」。</p>
                <p>(二) 本公司尊重使用者之隱私權，並致力於對使用者的資料加以保密。使用者應在使用本系統之前，詳細閱讀「使用者隱私權政策」，使用者瞭解當個人使用本服務時，即視同使用者同意本公司依據「使用者隱私權政策」蒐集、處理與利用使用者的個人資料，包括跨國間的傳輸與儲存及本系統及其關係企業內部之利用。</p>
                <p>四、使用者的守法義務及承諾</p>
                <p>您承諾絕不為任何非法目的或以任何非法方式使用本服務，並承諾遵守中華民國相關法規及一切使用網際網路之國際慣例。您若係中華民國以外之使用者，同意遵守所屬國家或地域之法令。您同意並保證不得利用本服務從事侵害他人權益或違法之行為，包括但不限於：</p>
                <p>(一) 干擾或中斷本服務或伺服器或連結本服務之網路，或不遵守連結至本服務之相關需求、程序、政策或規則等；</p>
                <p>(二) 冒用他人名義使用本服務；</p>
                <p>(三) 違反依法律或契約所應負之保密義務；</p>
                <p>(四) 偽造訊息來源或以任何方式干擾傳輸來源之認定；</p>
                <p>(五) 追蹤他人或其他干擾他人而蒐集或儲存他人之個人資訊；</p>
                <p>(六) 其他本公司有正當理由認為不適當之行為。</p>
                <p>五、免責聲明</p>
                <p>您明確了解並同意本公司之管理人、受僱人、代理人、合夥人及授權人， 無須為您任何直接、間接、附隨、特別、衍生、懲罰性的損害負責，包括但不限於因下述事由所生利潤、商譽、使用、資料之損害或其他無形損失（即令本服務曾被告知該等損害之可能性亦同）：</p>
                <p>(一) 使用或無法使用本服務。</p>
                <p>(二) 替代商品及服務之購買成本。</p>
                <p>(三) 他人未經授權存取或修改您的傳輸或資料。</p>
                <p>(四) 因使用本系統而無法儲存、遺失相關電子資料。</p>
                <p>(五) 任何第三人就本服務所為之聲明或行為。</p>
                <p>(六) 任何其他與本服務有關者。部分管轄區域並不允許對於特定保證責任的排除或是對於附隨或衍生損害的限制或免除。於此情形，本條前述限制對您不適用。</p>
                <p>六、本系統使用</p>
                <p>(一) 您同意在本系統所進行的所有線上填寫，都以本系統所自動記錄的電子資料為準，如有糾紛，亦以該電子資料為認定標準。若您發現填寫之資料不正確，應立即通知本系統。</p>
                <p>(二) 使用本系統後，如發現金額或服務項目需更改時，如已開立及取得實體發票(紙本)，並應連同發票一併退回；否則，本公司得拒絕退款或請款。</p>
                <p>(三) 依法或其他相關規定須為通知時，本公司得以包括但不限於：電子郵件、文字訊息、張貼於本服務網頁，或其他現在或未來合理之方式通知您，包括本服務使用條款之變更。但若您違反本服務使用條款，以未經授權的方式存取本服務，您將不會收到前述通知。當您經由授權的方式存取本服務，而同意本服務使用條款時，您即同意本公司所為之任何及所有給您的通知，都視為送達。</p>
                <p>(四) 您同意不對本服務任何部分或本服務（包括：資訊內容、廣告等）之使用或存取，進行重製、拷貝、出售、交易、轉售或作任何商業目的之使用。</p>
                <p>(五) 本公司保留於任何時點，不經通知隨時修改或暫時或永久停止繼續提供本服務（或其任一部分）的權利。您同意本公司對於您或是任何第三方對於任何修改、暫停或停止繼續提供本服務不負任何責任。</p>
                <p>(六) 您同意本公司得依其判斷因任何理由，包含但不限於一定期間未使用、法院或政府機關命令、本服務無法繼續或服務內容實質變更、無法預期之技術或安全因素或問題，或其他本公司認為您已經違反本服務使用條款的明文規定及精神，而終止或限制您使用本服務之使用，並將本服務內任何「個人資料」加以移除並刪除。您並同意本公司亦得依其自行之考量，於通知或未通知之情形下，隨時終止或限制您使用本服務或其任何部分。您承認並同意前開終止或限制，本公司得立即關閉、刪除或限制存取您的相關資料，及停止本服務全部或部分之使用。此外，您同意若本服務之使用被終止或限制時，本公司對您或任何第三人均不承擔責任。</p>
                <p>七、服務系統中斷、故障或停止</p>
                <p>如發生下列情形之一時，本公司有權可以停止、中斷提供本網站，使用者不得因此請求賠償或補償：</p>
                <p>(一)電子通信設備進行必要之保養及施工、突發性之電子通信設備故障。</p>
                <p>(二)對本系統網站相關軟硬體設備進行搬遷、更換、升級、保養或維修時。</p>
                <p>(三)使用者有任何違反法令、本使用者條款或本服務相關約定之情形。</p>
                <p>(四)因第三人之行為、非本公司所得以控制之事項、或其他不可歸責於本公司之事由所致之網站暫停、中斷或無法正常運作。</p>
                <p>(五)由於天災等不可抗力之因素或其他不可歸責於本公司所致之網站暫停、中斷或無法正常運作。</p>
                <p>(六)因本公司自身業務考量，包括但不限於商業合併、結束營業等。</p>
                <p>八、會員內容之保留與揭露</p>
                <p>使用者了解本公司並未針對「個人資料」事先加以審查，但本公司有權（但無義務）依其自行之考量，拒絕或移除經由本服務提供之任何「個人資料」。在不限制前開規定之前提下，本公司及其指定人有權將有違反本服務使用條款或法令之虞、或令人厭惡之任何「個人資料」加以移除。您了解並同意，依據法律的要求，或基於以下目的之合理必要範圍內，認定必須將您的個人資料加以保存或揭露予政府機關、司法警察或未成年人之監護人時，得加以保存及揭露：</p>
                <p>(一) 遵守法令或政府機關之要求。</p>
                <p>(二) 為提供本服務所必須者。</p>
                <p>(三) 為防止他人權益之重大危害而有必要者。</p>
                <p>(四) 為免除使用者及公眾之生命、身體、自由、權利、財產上之急迫危險者。</p>
                <p>九、責任範圍及限制</p>
                <p>(一) 本公司經由本系統提供之各項服務僅承擔本服務使用條款中所列明的相關責任。</p>
                <p>(二) 本系統上之資訊，均僅供參考，使用者就本服務所涉相關資料之正確性或可信性，應自行判斷、評估並自負風險。使用者藉由本服務取得各式資訊與資料所進行之任何合作，本公司均不擔保獲利或負擔任何保證責任。</p>
                <p>(三) 本公司對本系統不提供任何明示或默示的擔保，包含但不限於權利完整、商業適售性、特定目的之適用性及未侵害他人權利。使用者使用本服務時，須自行承擔相關風險。本公司不保證本系統：將符合使用者的需求；得以不受干擾地持續運作；資料得以被即時、安全可靠、正確無誤地傳輸、處理、儲存及備份；系統、軟體及資料之錯誤，將被即時發現及更正；使用者於本系統取得之任何產品、服務、資訊或其它資料將符合使用者的期望。</p>
                <p>(四) 公司並不保證本系統、伺服器、網域等所傳送的電子郵件或其內容不會含有電腦病毒等有害物；亦不保證郵件、檔案或資料之傳輸儲存均正確無誤不會斷線和出錯等，因各該郵件、檔案或資料傳送或儲存失敗、遺失或錯誤等所致之損害，本公司不負賠償責任。</p>
                <p>(五) 使用者自本系統所取得之資訊或建議，無論其係以書面或口頭方式呈現，均不構成本公司之保證。</p>
                <p>十、智慧財產權</p>
                <p>本公司所使用之軟體或程式、網站、系統上所有內容，包括但不限於著作、圖片、檔案、資訊、資料、網站架構、網站畫面的安排、網頁設計、使用者內容等，均由本公司或其他權利人依法擁有其智慧財產權，包括但不限於商標權、專利權、著作權、營業秘密與專有技術等。任何人不得逕自使用、修改、重製、公開播送、公開傳輸、公開演出、改作、散布、發行、公開發表、進行還原工程、解編或反向組譯。若您欲引用或轉載前述內容，除明確為法律所許可者外，必須依法取得本公司或其他權利人的事前書面同意。如有違反智慧財產權之情形，您應對本公司負損害賠償責任。本公司為宣傳本服務，就本服務相關之商品或服務名稱、圖樣等，依其註冊或使用之狀態，受商標法及公平交易法等之保護，未經本公司事前書面同意，您同意不以任何方式使用本公司商標。</p>
                <p>十一、 準據法及管轄法院</p>
                <p>(一) 關於「本服務使用條款」之解釋或適用，以中華民國之法律為準據法。</p>
                <p>(二) 使用者因使用「本服務」而與「本服務」所生之爭議，同意本誠信原則解決之，如有訴訟之必要時， 同意以臺灣臺北地方法院為第一審管轄法院。</p>
                </div>
            </Container>    
        </Box>
      </div>
    );
  }
  
  export default TermsOfUse;